import { render, staticRenderFns } from "./gc-header-form.vue?vue&type=template&id=64b6ebe6&scoped=true"
import script from "./gc-header-form.vue?vue&type=script&lang=js"
export * from "./gc-header-form.vue?vue&type=script&lang=js"
import style0 from "./gc-header-form.vue?vue&type=style&index=0&id=64b6ebe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6ebe6",
  null
  
)

export default component.exports